import React, {useEffect, useState} from 'react'
import firebase from "firebase";

var firebaseui = require('firebaseui');

var ui = new firebaseui.auth.AuthUI(firebase.auth());

function Login() {

    useEffect(()=> {
        if (!ui) {
            ui = new firebaseui.auth.AuthUI(firebase.auth());
        }

        ui.start('#firebaseui-auth-container', {
            callbacks: {
                signInSuccessWithAuthResult: function (authResult, redirectUrl) {
                    sessionStorage.setItem("userEmail", authResult.user.email)
                    sessionStorage.setItem("name", authResult.user.displayName)
                    sessionStorage.setItem("accessToken", authResult.credential.accessToken)
                },
                uiShown() {
                    document.querySelector('[data-provider-id="google.com"]').style.background="#11ABB0";
                }

            },
            signInFlow: 'popup',
            signInOptions: [
                // List of OAuth providers supported.
                {
                    provider: 'google.com',
                    providerName:"Google",
                    fullLabel:"Sign In with ",
                    iconUrl:"/images/google.svg"
                }

            ],

        })

    },[])


    return (
        <div>
        <div id = "firebaseui-auth-container" >
        </div>
        </div>
    )



}

export default Login;


// WEBPACK FOOTER //
// ./src/Components/Login.js